'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["small", "size", "indeterminate", "id", "children", "semanticColor", "isHover", "isFocus", "isActive"];
import React, { useContext } from 'react';
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.js";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.js";
import { textClass } from "../../styles/index.js";
import { VisuallyHidden } from "../VisuallyHidden/index.js";
import { Checkbox } from "./Checkbox.js";
import { Indicator } from "./Indicator.js";
import { Label } from "./Label.js";
import { TextForLabel } from "./TextForLabel.js";
/**
 * FormCheckbox allow users to select one or more items from a set, turn an option on or off, or acknowlege something. Used within a Form component.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-formcheckbox--docs) |
 * [Encore site](https://encore.spotify.net/web/components/selectors#checkbox) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormCheckbox) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12297&t=uvnU5TzlyKmXuODT-1)
 */
export var FormCheckbox = /*#__PURE__*/React.forwardRef(function FormCheckbox(_ref, ref) {
  var small = _ref.small,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    indeterminate = _ref.indeterminate,
    id = _ref.id,
    children = _ref.children,
    _ref$semanticColor = _ref.semanticColor,
    semanticColor = _ref$semanticColor === void 0 ? 'essentialBrightAccent' : _ref$semanticColor,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    isActive = _ref.isActive,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  return /*#__PURE__*/React.createElement(Checkbox, {
    "data-encore-id": ENCORE_DATA_IDS.FormCheckbox
  }, /*#__PURE__*/React.createElement(VisuallyHidden, Object.assign({
    component: "input",
    type: "checkbox",
    ref: ref,
    id: id
  }, props)), /*#__PURE__*/React.createElement(Label, {
    htmlFor: id
  }, /*#__PURE__*/React.createElement(Indicator, {
    className: indeterminate ? 'Encore_indeterminate' : '',
    $indeterminate: indeterminate,
    $isUsingKeyboard: isUsingKeyboard,
    $semanticColor: semanticColor,
    $isHover: isHover,
    $isFocus: isFocus,
    $isActive: isActive
  }), children && /*#__PURE__*/React.createElement(TextForLabel, {
    className: small || size === 'small' ? textClass('marginal') : textClass('bodySmall'),
    $size: small ? 'small' : size
  }, children)));
});